import React from "react";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const ReportHistoryBody = ({ reportData }) => {
  return (
    <TableBody>
      {reportData?.map((row, index) => {
        const {reportType, reportInfo, reportToken} = row
        return (
          <TableRow key={index}>
            <TableCell className="tableCell" align="center">
              {reportType}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {reportInfo}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {reportToken}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default ReportHistoryBody;
